export const paths = {
  index: '/',
  dashboard: '/dashboard',
  dsn: '-dsn',
  departmentDashboard: '/department-dashboard',
  restoreSkill: '/restore-skill',
  monthDayAlert: 'monthly-closeout-alerts/month-day-alert',
  monthlyCloseoutAlert: '/monthly-closeout-alerts',
  restoreCare: '/restore-care',
  restoreWellness: 'restore-wellness',
  reports: '/reports',
  patients: '/patients',
  patientDetails: 'patient-details',
  createPatient: 'add-new-patient',
  addNewScreening: '/add-new-screening',
  addNewEpisodeOfCare: '/add-new-episode-of-care',
  editEpisodeOfCare: '/edit-episode-of-care',
  screening: '/screening',
  sreeningDetails: '/screening-details',
  editPatient: '/edit-patient',
  deactivate: 'deactivate',
  episodeOfCare: '/episode-care',
  postAuthResetPassword: '/post-auth-forgot-password',
  laborManagement: {
    index: '/labor-management',
    myAvailability: 'my-availability',
    checkInCheckOut: 'check-in-check-out',
    laborReportAndApproval: 'labor-report-approval',
    laborHoursManagement: 'labor-hours-management',
  },
  auth: {
    login: '/auth/login',
    resetPassword: '/auth/reset-password',
    forgotPassword: '/forgot-password',
  },
  docs: 'https://material-kit-pro-react-docs.devias.io',
  schedule: {
    index: '/scheduling',
    therapistSchedule: 'therapist',
    therapyPlanning: {
      index: 'therapy-planning',
      details: '/details',
      info: '/info',
      editDetails: '/edit-details',
    },
  },
  editFacilityStay: '/edit-facility-stay',
  addFacilityStay: 'add-facility-stay',
  details: 'details',
  therapyPlanning: {
    index: '/scheduling/therapy-planning',
    details: '/details',
    info: '/info',
    editDetails: '/edit-details',
    authorization: '/authorization',
    editAuthorization: '/edit-authorization',
  },
  facilityStay: 'facility-stay',
  dailySessionNotes: '/daily-session-notes',
  landingPage: '/auth/landing-page',
  landingPageLogout: '/auth/logout-landing',
  previewDocument: '/preview-document',
  editDocument: '/edit-document',
  createDocument: '/create-document',
  physicianSign: '/physician-sign-document',
  getSignaturePreview: '/signature-preview',
  // getSignaturePreviewOld:'/signature-preview-dsn',
  finalizeNotes: '/finalize-soap-notes',
  redirectSupervisor: '/redirect-location',
  mdsCommunication: '/mds-communication',
  addMdsCommunication: '/add',
  editMdsCommunication: '/edit',
  viewMdsCommunication: '/view',
  signMds: '/sign-mds',
  evalMds: '/add/eval-mds',
  recertiMds: '/add/recert-mds',
  dischargeMds: '/add/discharge-mds',
  physicianDashboard: '/physician-dashboard',
  physicianDocumentsSign: `/physician-dashboard/documents-sign`
};

export const permissions = {
  READ_PATIENT: 'Read Patient',
  UPDATE_PATIENT: 'Update Patient',
  CREATE_PATIENT: 'Create Patient',
  ACTIVATE_PATIENT: 'Activate Patient',
  DEACTIVATE_PATIENT: 'Deactivate Patient',
  READ_DASHBOARD: 'Read Dashboard Self',
  READ_DEPARTMENT_DASHBOARD: 'Read Dashboard',
  READ_SCREENINGS: 'Read Screening',
  CREATE_SCREENINGS: 'Create Screening',
  UPDATE_SCREENINGS: 'Update Screening',
  READ_EPISODE_OF_CARE: 'Read Episode Of Care',
  CREATE_EPISODE_OF_CARE: 'Create Episode Of Care',
  UPDATE_EPISODE_OF_CARE: 'Update Episode Of Care',
  CLOSE_EPISODE_OF_CARE: 'Close Episode Of Care',
  READ_DAILY_SESSION_NOTES: 'Read Daily Notes',
  UPDATE_DAILY_SESSION_NOTES: 'Update Daily Notes',
  READ_THERAPIST_PLANNING: 'Read Therapy Planning',
  UPDATE_THERAPIST_PLANNING: 'Update Therapy Planning',
  READ_THERAPIST_SCHEDULING: 'Read Daily Task',
  ADD_DAILY_TASK: 'Add Daily Task',
  UPDATE_DAILY_TASK: 'Update Daily Task',
  CREATE_AVAILABILITY: 'Create Availability',
  UPDATE_AVAILABILITY: 'Update Availability',
  READ_MY_AVAILABILITY: 'Read Availability',
  READ_MONTH_END_ALERT: 'Read Month End Alert',
  CREATE_RECERTIFICATION: 'Create Recertification',
  READ_RECERTIFICATION: 'Read Recertification',
  UPDATE_RECERTIFICATION: 'Update Recertification',
  READ_EVAL: 'Read Eval',
  UPDATE_EVAL: 'Update Eval',
  CREATE_EVAL: 'Create Eval',
  READ_PTO: 'Read PTO',
  CREATE_PTO: 'Create PTO',
  LABOR_MANAGEMENT: 'Labor Management',
  LABOR_MANAGEMENT_ADD: 'Create Labor Management',
  LABOR_MANAGEMENT_DELETE: 'Delete Labor Management',
  LABOR_MANAGEMENT_UPDATE: 'Update Labor Management',
  READ_JURY_CODE: 'Apply JURY Labor Code',
  READ_PTO_CODE: 'Apply PTO Labor Code',
  READ_HOL_CODE: 'Apply HOL Labor Code',
  READ_PRNEDU_CODE: 'Apply PRNEDU Labor Code',
  READ_REHAV_TRAV_CODE: 'Apply Rehab Trav Labor Code',
  READ_BEREV_CODE: 'Apply BEREV Labor Code',
  READ_FLOAT_CODE: 'Apply Float Labor Code',
};
